import { NotificationService } from 'src/app/shared/services/notification-service/notification.service';
import { AdminService, FileService } from 'src/app/services/property-matrix/services';
import { PropertyMatrixSharedService } from 'src/app/property-matrix-shared.service';
import { AdminEditDialogModel } from 'src/app/models/admin-edit-dialog-model';
import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { map } from 'rxjs';

import { AdminMyProfileDocumentsEditDialogComponent } from './admin-my-profile-documents-edit-dialog/admin-my-profile-documents-edit-dialog.component';

@Component({
  selector: 'app-admin-my-profile-documents',
  templateUrl: './admin-my-profile-documents.component.html',
  styleUrls: ['./admin-my-profile-documents.component.scss']
})
export class AdminMyProfileDocumentsComponent implements OnInit {

  documentDetails: any[] = [
    { key: 1, value: null, title: 'Documents' },
  ];

  constructor(
    private adminService: AdminService,
    private sharedService: PropertyMatrixSharedService,
    private fileService: FileService,
    public dialog: MatDialog,
    private notificationService: NotificationService
  ) { }

  ngOnInit(): void {
    this.getDocuments();
  }

  getDocuments() {
    let userName = this.sharedService.getUsername();

    this.adminService.apiV1AdminGetDocumentsGet$Response({ username: userName })
      .pipe(map(m => { return m })).subscribe({
        next: (result: any) => {
          let body = JSON.parse(result.body);
          this.documentDetails[0].value = body;
        },
        error: (error) => {
          this.notificationService.showErrorMessage('Error', 'Could not fetch data.');
        }
      });
  }

  editInfo(typeKey: number) {
    let data = this.documentDetails.find(f => f.key == typeKey);
    const dialogRef = this.dialog.open(AdminMyProfileDocumentsEditDialogComponent, {
      maxHeight: '80vh',
      data: { editType: typeKey, data: data } as AdminEditDialogModel,
    },);

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getDocuments();
      }
    });
  }

  async downloadDocument(document: any) {
    this.fileService.apiV1FileDownloadFileGet$Response({ fileId: document.fileId })
      .pipe(map(m => { return m })).subscribe({
        next: async (result: any) => {
          let dataURI = result.body
          var blob = await (await fetch(dataURI)).blob();
          let filename = `${document.fileTypeName}${document.fileType}`;
        },
        error: (error) => {
          this.notificationService.showErrorMessage('Error', 'Could not fetch data.');
        }
      })
  }
}